module.exports=function(scope){ return `curl -X POST \
'https://your.internal.zoomserver.instance.url/id-check' \
-H 'Content-Type: application/json' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE' \
-d '{
  "faceMap": INSERT_FACEMAP_DATA_AS_BASE64_HERE,
  "idScan": INSERT_ID_SCAN_HERE,
  "idScanFrontImage": INSERT_ID_SCAN_FRONT_IMAGE_DATA_AS_BASE64_HERE,
  "idScanBackImage": INSERT_ID_SCAN_BACK_IMAGE_DATA_AS_BASE64_HERE
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/bash/id-check.bash.tpl